import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EDomain } from '../base/types';
import { IDomainSortedExercises, IExercise, IUpdateDomainPayload } from './types';

export interface IExercisesState extends IDomainSortedExercises {
  users?: {
    [userId: number]: IDomainSortedExercises;
  };
}

export const emptyDomainState: IDomainSortedExercises = {
  [EDomain.Speed]: [],
  [EDomain.Reasoning]: [],
  [EDomain.Attention]: [],
  [EDomain.Memory]: [],
};

export const initialState: IExercisesState = {
  [EDomain.Speed]: [],
  [EDomain.Reasoning]: [],
  [EDomain.Attention]: [],
  [EDomain.Memory]: [],
};

export const statePropName = 'exercises';

const exercisesSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    initExercises(state, action: PayloadAction<number | undefined>) {
      const userId = action.payload;
      if (!userId) {
        // reset list of exercise on page visit
        // while there might have been some changes in preferences
        return {
          ...initialState,
        };
      }
      // reset state for given user
      const usersState = state.users || {};
      return {
        ...state,
        users: {
          ...usersState,
          [userId]: { ...emptyDomainState },
        },
      };
    },
    openExercises(state) {
      // No state change needed for opening exercises
    },
    updateDomain: {
      reducer(state, action: PayloadAction<IUpdateDomainPayload>) {
        const { domain, exercises, userId } = action.payload;
        if (!userId) {
          return {
            ...state,
            [domain]: exercises,
          };
        }
        const usersState = state.users || {};
        const userState = usersState[userId] || { ...emptyDomainState };
        const updatedUserState: IDomainSortedExercises = {
          ...userState,
          [domain]: exercises,
        };
        const updatedUsersState = {
          ...usersState,
          [userId]: updatedUserState,
        };
        return {
          ...state,
          users: updatedUsersState,
        };
      },
      prepare(domain: EDomain, exercises: IExercise[], userId?: number) {
        return {
          payload: {
            domain,
            exercises,
            userId,
          },
        };
      },
    },
  },
});

export const ExercisesActions = exercisesSlice.actions;
export default exercisesSlice.reducer;
